import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, XIcon } from 'lucide-react';
const names = ['Marie L.', 'Lucas C.', 'Chloé G.', 'Hugo R.', 'Léa S.', 'Maxime F.', 'Manon M.', 'Alexandre P.', 'Inès T.', 'Romain B.', 'Pauline V.', 'Mathieu H.', 'Clara D.', 'Kevin A.', 'Laura N.', 'Quentin K.', 'Océane O.', 'Florian E.', 'Justine I.', 'Guillaume W.', 'Anaïs Z.', 'Benjamin J.', 'Mélanie Q.', 'Adrien U.', 'Céline X.'];
const cities = ['Paris', 'Lyon', 'Marseille', 'Toulouse', 'Nice', 'Nantes', 'Bordeaux', 'Lille', 'Strasbourg', 'Montpellier', 'Rennes', 'Reims', 'Toulon', 'Grenoble', 'Dijon', 'Angers', 'Le Havre', 'Clermont-Ferrand', 'Tours', 'Limoges', 'Aix-en-Provence', 'Perpignan', 'Annecy'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    function showNotification() {
      setData({
        name: getRandomItem(names),
        city: getRandomItem(cities),
        minutes: Math.floor(Math.random() * 15) + 2
      });
      setVisible(true);
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => setVisible(false), 4000);
    }
    const initialTimeout = setTimeout(showNotification, 15000);
    const interval = setInterval(showNotification, 35000 + Math.random() * 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-383" data-mp="1034egrb6dlkf">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -24
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -24
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-4 z-[60] max-w-xs md:bottom-6" role="status" data-id="element-384" data-mp="1045u7934yw8h">
          <div className="flex items-start gap-3 rounded-2xl border border-white/10 bg-slate-900/95 p-3.5 shadow-2xl shadow-black/50 backdrop-blur-md" data-id="element-385" data-mp="1h6bkvfb5f63b">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-500/15" data-id="element-386" data-mp="1r2668i6rbf9s">
              <ShoppingBag size={18} className="text-emerald-400" aria-hidden="true" data-id="element-387" data-mp="1vto7768s5fur" />
            </div>
            <div className="min-w-0" data-id="element-388" data-mp="20rg0o4p2pa12">
              <p className="text-sm font-semibold text-white" data-id="element-389" data-mp="20ukcno8s5a2a">
                {data.name} à {data.city}
              </p>
              <p className="text-xs text-slate-300" data-id="element-390" data-mp="29t60nyx0thag">
                a acheté <span className="font-semibold text-sky-400" data-id="element-391" data-mp="29tz16i5dzak5">Fitness Fonctionnel 365</span>
              </p>
              <p className="mt-0.5 text-xs text-slate-500" data-id="element-392" data-mp="2erha48jelps5">il y a {data.minutes} minutes</p>
            </div>
            <button onClick={() => setVisible(false)} className="ml-auto mt-0.5 shrink-0 text-slate-500 transition-colors duration-150 hover:text-white" aria-label="Fermer la notification" data-id="element-393" data-mp="fh945rjq1l8j">
              <XIcon size={14} aria-hidden="true" data-id="element-394" data-mp="83qdjf9zny1v" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}